module.exports = __webpack_public_path__ + "1f7ccfd14066c1c779bc082c33a0823f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/gallery/scarring/scarring-1b.jpg
 ** module id = 444
 ** module chunks = 0
 **/